module.exports = __webpack_public_path__ + "img/row-of-business-people.f184257c.jpg";